import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const Input = styled.input`
  padding: 6px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s;
  outline: none;

  &:hover {
    border-color: #1976d2;
  }

  &:focus {
    border-color: #1976d2;
  }
`;

const Container = styled.div``;

const CommentSection = styled.p`
  font-weight: bold;
  font-size: 12px;
`;

const DropzoneWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  border: 2px dashed ${theme.colors.borderColor};
  border-color: ${theme.colors.lightBlue};
  border-radius: 7px;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
  outline: none;
  tabindex: 0;
  cursor: pointer;
`;

const UploadIcon = styled(InnoIcons.CloudUploadOutlinedIcon)`
  font-size: 20px;
  color: ${theme.colors.blue};
  margin: 0px;
  padding: 0px;
`;

const Span = styled.span``;

const DropzoneText = styled.span`
  font-size: 0.5rem;
  color: ${theme.colors.dropzonetext};
`;

const PreviewsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

const PreviewBox = styled.div`
  display: flex;
  position: relative;
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 7px;
  padding: 15px;
  width: 100%;
  height: 50px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const RemoveButton = styled.button`
  position: relative;
  margin-top: 5px;
  right: 0;
  background: ${theme.colors.buttonBackground};
  border: none;
  color: ${theme.colors.buttonText};
  padding: 5px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 3px;
  transition: background 0.3s ease;
`;

const FileName = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: black;
  max-width: 100px;
  white-space: nowrap;
  margin: 0px 5px 0px 5px;
`;

const UploadFileContiner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 40px;
`;

const StyledSpan = styled.span`
  color: ${theme.colors.blue};
  cursor: pointer;
  margin-left: 5px;
`;

const CloseIcon = styled(InnoIcons.CancelIcon)`
  font-size: 20px;
  color: ${theme.colors.red};
  cursor: pointer;
`;

const Image = styled.img`
  margin-right: 8px;
`;
const InputFile = styled.input``;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 20px;
`;

const SendIcon = styled(InnoIcons.SendIcon)`
  font-size: 18px;
  color: ${theme.colors.white};
  margin: 0px 0px 2px 5px;
`;

const ErrorSpan = styled.span`
  color: ${theme.colors.red};
  font-size: 11px;
  text-align: center;
  display: flex;
`;

const divContainer = styled.div``;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 1;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 0px 15px;
  margin: 0px 0px 15px 0px;
`;

const Children = styled.div`
  flex: 2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

// near your component file

/* Scoped styles — affect only Quill inside this wrapper */
const QuillWrapper = styled.div`
  & .ql-editor {
    word-wrap: break-word;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;
    max-width: 100%;
    overflow-y: auto;
    line-height: 2;
    /* optional: ensure padding doesn't collapse */
    box-sizing: border-box;
  }

  & .ql-container {
    max-height: 300px !important;
    display: flex;
    flex-direction: column;
  }
`;

const SC = {
  Input,
  Container,
  CommentSection,
  DropzoneWrapper,
  UploadIcon,
  DropzoneText,
  PreviewsContainer,
  PreviewBox,
  RemoveButton,
  FileName,
  Span,
  UploadFileContiner,
  StyledSpan,
  CloseIcon,
  Image,
  InputFile,
  ButtonContainer,
  SendIcon,
  ErrorSpan,
  divContainer,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  QuillWrapper,
};

export default SC;
